






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PleaseWait extends Vue {
  
  @Prop({ default: '',  type: String}) label!: string;

  dots:string = '';
  interval:number = 0;

  mounted() {
    this.interval = window.setInterval(() => this.dotUpdate(), 500);
  }

  dotUpdate() {
    this.dots =  this.dots.length < 3 ? (this.dots + '.') : '';
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }


}
